/** 챗 입력창 아래 추천 질문 칩 */
export const SUGGESTED_QUESTIONS = [
    "가장 어려웠던 문제는 뭐였나요?",
    "사용자 경험을 위해 뭘 신경 쓰나요?",
    "AI를 개발에 어떻게 활용하나요?",
    "팀에서는 어떤 식으로 일하나요?",
] as const;
